export * from "./messaging.service";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/messaging/index.ts